import axios from 'axios';

export default {
  fetchUserList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/user', {
      params: paginationParams,
    })
      .then((users) => {
        commit('setData', users);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  deleteUser(_, user) {
    return axios.delete(`/user/${user.id}`);
  },
};
